import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';

export const StyledFlexbox = styled.div`
  display: flex;
  width: ${({ w = 'auto' }) => w};
  align-items: ${({ align }) => align || 'flex-start'};
  justify-content: ${({ justify }) => justify || 'flex-start'};
  flex-direction: ${({ direction }) => direction || 'row'};
  margin-top: ${ ({ marginTop = 0 }) => `${marginTop}px` };
  padding: ${ ({ px = 0, py = 0 }) => `${py}px ${px}px` };
  margin-bottom: ${ ({ marginBottom = 0 }) => `${marginBottom}px` };
  position: relative;

  ${respondTo.desktop`
    justify-content: ${({ justify }) => justify || 'flex-end'};
  `}
`;
